import { render, staticRenderFns } from "./offer-pill.vue?vue&type=template&id=55773f15&scoped=true"
import script from "./offer-pill.vue?vue&type=script&lang=js"
export * from "./offer-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55773f15",
  null
  
)

export default component.exports